import { IQuickSummaryProps } from "./QuickSummary";

export const View = (props: IQuickSummaryProps) => {
  return (
    <div className="quicksummary flex-container col">
      <div className="flex-box flex-container title-container align-items--center">
        <div className="font-ctm--semibold">{props.title}</div>

        <div
          className="quicksummary-icon--container"
          style={{ backgroundColor: props.iconBackground }}
        >
          {props.icon}
        </div>
      </div>

      <div>
        <h4 className="font-ctm--bold">{props.value}</h4>
      </div>
    </div>
  );
};
